<script setup>
import { useI18n } from "vue-i18n";
import { FormInput, FormListbox, FormLabel } from "@Components/Form";

defineProps(["modelValue"]);
defineEmits(["update:modelValue"]);

const { t: __ } = useI18n();

const nodes = [
    {
        key: "p",
        name: "Paragraph",
    },
    {
        key: "h1",
        name: "Heading 1",
    },
    {
        key: "h2",
        name: "Heading 2",
    },
    {
        key: "h3",
        name: "Heading 3",
    },
    {
        key: "h4",
        name: "Heading 4",
    },
    {
        key: "h5",
        name: "Heading 5",
    },
];
</script>

<template>
    <div>
        <FormLabel for="linking-automatic-template-title-value">{{ __("Titre") }}</FormLabel>
        <div class="flex items-center mt-2 space-x-3">
            <div class="flex-none">
                <FormListbox v-model="modelValue.title.node" :items="nodes" item-key="key" item-display="name" required />
            </div>
            <div class="flex-1">
                <FormInput id="linking-automatic-template-title-value" v-model="modelValue.title.value" />
            </div>
        </div>
    </div>
</template>
